/**
 * Converts Firebase Auth error codes to user-friendly messages
 * @param {Error} error - The error object from Firebase
 * @returns {string} User-friendly error message
 */
export const getAuthErrorMessage = (error) => {
  if (!error || !error.code) return 'An unexpected error occurred. Please try again.';

  const errorMap = {
    // Authentication errors
    'auth/email-already-in-use': 'This email is already registered. Please use a different email or sign in.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/weak-password': 'Password should be at least 6 characters long.',
    'auth/user-not-found': 'No account found with this email. Please sign up first.',
    'auth/wrong-password': 'Incorrect password. Please try again.',
    'auth/too-many-requests': 'Too many failed attempts. Please try again later or reset your password.',
    'auth/network-request-failed': 'Network error. Please check your connection and try again.',
    'auth/requires-recent-login': 'This operation requires you to re-authenticate. Please sign in again.',
    'auth/user-disabled': 'This account has been disabled. Please contact support.',
    'auth/operation-not-allowed': 'This operation is not allowed. Please contact support.',
    'auth/account-exists-with-different-credential': 'An account already exists with the same email but different sign-in credentials.',
    
    // Firestore errors
    'permission-denied': 'You do not have permission to perform this action.',
    'unavailable': 'Service is currently unavailable. Please try again later.',
  };

  return errorMap[error.code] || 'An error occurred. Please try again.';
};

/**
 * Handles errors and returns a user-friendly message
 * @param {Error} error - The error object
 * @param {string} defaultMessage - Default message if error type is not recognized
 * @returns {string} User-friendly error message
 */
export const handleError = (error, defaultMessage = 'An error occurred. Please try again.') => {
  console.error('Error:', error);
  
  if (error?.code?.startsWith('auth/')) {
    return getAuthErrorMessage(error);
  }
  
  return error?.message || defaultMessage;
};
